import { FC } from 'react';
import { ModalBodyProps } from '@chakra-ui/react';

import laptopImage from 'assets/brand/laptop.png';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';

import Input from './components/Input';

interface BodyParts {
  Title: typeof SunshineModal.Title;
  Description: typeof Text;
  Input: typeof Input;
}

const Body: FC<ModalBodyProps> & BodyParts = ({ children, ...props }) => (
  <SunshineModal.Body {...props}>
    <SunshineModal.Body.Image src={laptopImage} />
    {children}
  </SunshineModal.Body>
);

Body.Title = SunshineModal.Title;
Body.Description = Text;
Body.Input = Input;

export default Body;
